import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    
    // Escキーで閉じる
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  open(event) {
    event.preventDefault()
    
    const trigger = event.currentTarget
    const modalId = trigger.getAttribute('data-modal-target')
    
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.style.display = 'flex'
    } else {
      console.error("2021 Winter - Modal not found:", modalId)
    }
  }

  close(event) {
    event.preventDefault()
    
    const closer = event.currentTarget
    const modalId = closer.getAttribute('data-modal-close')
    
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.style.display = 'none'
    } else {
      console.error("2021 Winter - Modal not found:", modalId)
    }
  }

  clickOutside(event) {
    if (event.target === event.currentTarget) {
      event.target.style.display = 'none'
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      const openModals = document.querySelectorAll('.modal-wrapper[style*="flex"]')
      openModals.forEach(modal => {
        modal.style.display = 'none'
      })
    }
  }
}
